import { z } from "zod";

import { branded } from "@/lib/helpers/branded-helper";
import { simpleCompanyDtoSchema } from "@/types/backoffice/dto/company/simple-company-dto.ts";

export const operationTypeDtoSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export const operationDtoSchema = z.object({
  id: branded.operationId,
  name: z.string(),
  partner: simpleCompanyDtoSchema,
  type: operationTypeDtoSchema,
});

export type TOperationDto = z.infer<typeof operationDtoSchema>;
export type TOperationTypeDto = z.infer<typeof operationTypeDtoSchema>;
